export const formatarDataHoraUtcPtBr = (dataISO) => {
	if (!dataISO) return "-";

	const data = new Date(dataISO);

	if (Number.isNaN(data.getTime())) {
		return "-";
	}

	return data.toLocaleString("pt-BR", {
		timeZone: "UTC",
	});
};

export const normalizarTexto = (texto = "") => {
	return texto
		.toString()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.toLowerCase();
};

export const ehEventoObito = (item = {}) => {
	const conteudo = [item.status, item.diretriz, item.descricao]
		.filter(Boolean)
		.join(" ");

	return normalizarTexto(conteudo).includes("obito");
};
